import React from 'react'

const PendingChart = ({ title, value }) => {
    return (
        <div className='c-pending-content' style={{flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center'}}>
            <div className='c-pending-title'>
                <p>{title}</p>
            </div>
            <div className='pending-value'>
                <p>{value}</p>
            </div>
        </div>
    )
}

export default PendingChart;